import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import App from './App';
import { initAnalytics } from './analytics';
import { initSentry } from './sentry';
import { keepBackendWarm } from './lib/warm';

initSentry();
initAnalytics();
keepBackendWarm();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
